import { BarChart as RechartsBarChart, Bar as RechartsBar } from 'recharts';

import { getColor, getOpagueColor } from '@nxs/utils';
import { IGenericChartProps } from './models';

export function BarChart<T>(props: IGenericChartProps<T>) {

    const {
        data,
        width,
        height,
        children,
        dataKeys,
        disabledKeys
    } = props;

    return (
        <RechartsBarChart
            data={data}
            width={width}
            height={height}
            className='chart'
            margin={{ left: -20 }}
        >
            {children}
            {
                dataKeys
                    .filter(x => disabledKeys.indexOf(x.dataKey) < 0)
                    .map(dataKey => (
                        <RechartsBar
                            key={dataKey.dataKey as any}
                            name={dataKey.legendName}
                            dataKey={dataKey.dataKey as any}
                            stroke={getColor(dataKey.color)}
                            fill={getOpagueColor(dataKey.color, 0.7)}
                            stackId={dataKey.stackKey ?? dataKey.dataKey as any}
                            id={dataKey.dataKey as any}
                            animationDuration={500}
                            animationBegin={0}
                        />
                    ))
            }
        </RechartsBarChart>
    )
};